export default "__VITE_ASSET__DaMkPpIw__"